export const PROVIDER_CREDITS_EXHAUSTED_CODE = 'PROVIDER_CREDITS_EXHAUSTED';

// Codici canonici provider-neutral emessi dalla facade di generazione
// (batch 5, docs/martina-provider-neutral-plan.md). Gli alias legacy con
// nome vendor restano accettati in lettura: vivono nel layer adapter
// (server/modules/exai/providers/legacyErrorAliases.ts) perche' qui dentro
// il contratto vieta letterali di vendor.
export const PROVIDER_API_KEY_MISSING_CODE = 'PROVIDER_API_KEY_MISSING';
export const PROVIDER_API_ERROR_PREFIX = 'PROVIDER_API_ERROR';
export const PROVIDER_CREDITS_EXHAUSTED_MESSAGE = 'Il credito per utilizzare l’intelligenza artificiale è esaurito. Martina resta disponibile in modalità locale per le funzioni di lettura del CRM.';

export function isProviderCreditsExhaustedText(value: unknown): boolean {
  const text = typeof value === 'string' ? value : JSON.stringify(value ?? '');
  return /credit balance is too low|insufficient.*credit|billing|purchase credits|provider_credits_exhausted/i.test(text);
}
